import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';

import { Subscription } from 'rxjs';

import { SurveyEditorService } from '../../../../services/survey-editor.service';

@Component({
  selector: 'empathy-ranking-settings',
  templateUrl: './ranking-settings.component.html',
  styleUrls: ['./ranking-settings.component.scss', './_ranking-settings-theme.component.scss']
})
export class RankingSettingsComponent  implements OnInit, OnDestroy {
  surveyEditorService = inject(SurveyEditorService);

  activeQuestion$ = signal(this.surveyEditorService.surveyEditor$().activeQuestion);

  private subscription: Subscription;

  ngOnInit(): void {
    this.subscription = this.surveyEditorService.surveyEditor$().questionActivated$.subscribe(() => {
      this.activeQuestion$.set(this.surveyEditorService.surveyEditor$().activeQuestion);
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
